import { render, staticRenderFns } from "./ChangeOptions.vue?vue&type=template&id=8b85497c"
import script from "./ChangeOptions.vue?vue&type=script&lang=js"
export * from "./ChangeOptions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports